module.exports = __webpack_public_path__ + "img/campagnia.2294d63a.png";